<div class="input-field flex-col">
    <div class="flex-row space-between-center gap-8">
        <mat-label> {{ title() | translate }}</mat-label>

        <ui-button type="noBorderPrimary"
                   (clickAction)="addParams()">
            {{ 'COMMON.ADD'|translate }}
        </ui-button>
    </div>

    <div class="virtual-scroll-container w-100">
        <section class="virtual-scroll-table w-100">
            <header>
                <div class="col flex">
                    <div class="inner">
                        {{ 'CREATE_OAUTH_PROVIDER_MODAL.VALUE'|translate }}
                    </div>
                </div>
                <div class="col flex"
                     style="max-width: 50px;">
                    <div class="inner">
                    </div>
                </div>
            </header>
            @for( row of paramsControls()|keyvalue; track row; let i = $index) {
            <div class="row-wrapper row c-p">
                <ng-container [formGroup]="$any(row.value)">
                    <div class="col flex">
                        <div class="inner">
                            <input type="text"
                                   formControlName="value">
                        </div>
                    </div>
                    <div class="col flex delete"
                         style="max-width: 50px">
                        <div class="inner"
                             (click)="deleteParams(i)">
                            <span class="ui-icon-delete"></span>
                        </div>
                    </div>
                </ng-container>
            </div>
            }
        </section>
    </div>
</div>